import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  public apiEndPoint = apiParameters.url;

  constructor(private http: HttpClient) {}

  /**
   * This method gets inventar products from backend
   * @param inventarId - id of the selected inventar
   * @param page - number of the pagination page
   * @param limit - number of items per page
   * @returns - list of products
   */
  getInventarProducts(
    inventarId: string,
    page: number,
    limit: number,
    title?: string,
    userId?: string,
    from?: string,
    to?: string,
    statusOptions?: string[]
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (title && title !== '') {
      searchParams = searchParams.append('title', title);
    }

    if (from && from !== '') {
      searchParams = searchParams.append('from', from);
    }
    if (to && to !== '') {
      searchParams = searchParams.append('to', to);
    }

    if (userId && userId !== '' && userId !== 'undefined') {
      searchParams = searchParams.append('userId', userId);
    }

    if (statusOptions && statusOptions.length > 0) {
      statusOptions.forEach((status) => {
        searchParams = searchParams.append('status[]', status);
      });
    }

    const httpOptions = {
      params: searchParams,
      headers: new HttpHeaders({
        page: page.toString(),
        limit: limit.toString(),
      }),
    };

    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/products`,
      httpOptions
    );
  }

  /**
   * This method gets one inventar product from backend
   * @param inventarId - id of the selected inventar
   * @param productId - id of the selected product
   * @returns - one product object
   */
  getInventarProductById(
    inventarId: string,
    productId: string
  ): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/products/${productId}`
    );
  }

  createInventarProducts(inventarId: string, body: any): Observable<any> {
    return this.http.post(
      `${apiParameters.url}/inventars/${inventarId}/products`,
      body
    );
  }

  deleteProduct(inventarId: string, productId: string): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/inventars/${inventarId}/products/${productId}`
    );
  }

  getDeleteProduct(inventarId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/deleted-products`
    );
  }

  updateProduct(
    inventarId: string,
    productId: string,
    body: any
  ): Observable<any> {
    return this.http.patch(
      `${apiParameters.url}/inventars/${inventarId}/products/${productId}`,
      body
    );
  }

  getInventarProductInCsv(
    inventarId: string,
    from?: string,
    to?: string
  ): Observable<any> {
    let searchParams = new HttpParams();

    from && from !== ''
      ? (searchParams = searchParams.append('from', from))
      : null;
    to && to !== '' ? (searchParams = searchParams.append('to', to)) : null;

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'text/csv' }),
      responseType: 'text' as 'text',
      params: searchParams,
    };

    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/products-csv`,
      httpOptions
    );
  }

  getProductActivityLog(
    inventarId: string,
    productId: string
  ): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/products/${productId}/activity-log`
    );
  }

  getAllProducts(
    page: number,
    limit: number,
    companyId?: string,
    title?: string,
    username?: string,
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (companyId && companyId !== '') {
      searchParams = searchParams.append('companyId', companyId);
    }

    if (title && title !== '') {
      searchParams = searchParams.append('title', title);
    }

    if (username && username !== '') {
      searchParams = searchParams.append('username', username);
    }

    const httpOptions = {
      params: searchParams,
      headers: new HttpHeaders({
        page: page.toString(),
        limit: limit.toString(),
      }),
    };

    return this.http.get(
      `${apiParameters.url}/products`,
      httpOptions
    );
  }
}
